import { render } from "./InsurancePage.vue?vue&type=template&id=0667df99&scoped=true"
import script from "./InsurancePage.vue?vue&type=script&lang=js"
export * from "./InsurancePage.vue?vue&type=script&lang=js"

import "./InsurancePage.vue?vue&type=style&index=0&id=0667df99&lang=css"
import "./InsurancePage.vue?vue&type=style&index=1&id=0667df99&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0667df99"]])

export default __exports__